import React, { Component } from 'react';
import { get } from 'lodash';
import PropTypes from 'prop-types';
import { View, Image } from '@zhike/ti-ui';
import { Article, Audio } from '@zhike/ti-component';
import { cdnUrl } from 'common/config';
import RenderIndex from 'components/report/common/render_index';
import imgAnswerAnalysis from './assets/answerAnalysis.png';
import styles from './styles';


export default class Report extends Component {
  // 参数
  static propTypes = {
    questions: PropTypes.array.isRequired,
    question: PropTypes.object.isRequired,
    match: PropTypes.object.isRequired,
  };
  // 构造函数
  constructor(props) {
    super(props);
    this.state = {
      isReport: true,
    };
  }

  // 渲染
  render() {
    const { question, questions, match } = this.props;
    const { isReport } = this.state;
    const direction = get(question, 'materials[0].direction');
    const stem = get(question, 'stem');
    const origin = get(question, 'materials[0].origin');
    const analysis = get(question, 'materials.0.analysis');
    const exampleSrc = get(question, 'materials.0.examples.0.audio.src');
    const audioSrc = get(question, 'materials.0.userAnswer.answer.src');
    return (
      <View className={styles.container}>
        <View className={styles.left}>
          <View className={styles.result}>
            <RenderIndex
              questions={questions}
              question={question}
              match={match}
            />
            <View className={styles.text}>
              {
                direction &&
                  <Article
                    isReport={isReport}
                    material={direction}
                  />
              }
              {
                origin &&
                  <Article
                    isReport={isReport}
                    material={origin}
                  />
              }
              {
                stem &&
                  <Article
                    isReport={isReport}
                    material={stem}
                  />
                }
              {
                audioSrc &&
                <View>
                  <View className={styles.div}>我的录音</View>
                  <View className={styles.div}>
                    <Audio src={audioSrc} progressWidth={348} cdnUrl={cdnUrl} />
                  </View>
                </View>
              }
              {
                exampleSrc &&
                <View>
                  <View className={styles.div}>范例音频</View>
                  <View className={styles.div}>
                    <Audio src={exampleSrc} progressWidth={348} cdnUrl={cdnUrl} />
                  </View>
                </View>
              }
            </View>
          </View>
        </View>
        <View className={styles.rigth}>
          <View className={styles.analysis}>
            <View className={styles.title1}>
              <View className={styles.icon} />
              <View className={styles.answerAnalysis}>答案解析</View>
            </View>
            <View className={styles.textRigth}>
              {
                analysis &&
                  <Article
                    material={analysis}
                    isReport={isReport}
                  />
              }
              {
                (!analysis ||
                !analysis.paragraphs ||
                (Array.isArray(analysis.paragraphs) && analysis.paragraphs.length === 0)) &&
                  <View className={[styles.text1, styles.textContent]}>
                    <Image src={imgAnswerAnalysis} className={styles.image} />
                    暂无答案解析哦~
                  </View>
              }
            </View>
          </View>
        </View>
      </View>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/report/base_report/speaking_report/index.js